import styled from "@emotion/styled"

import { body100, headline100, headline50, surtitle100, surtitle50 } from "css/text"

import { useConsole } from "contexts/Console"

import Link from "components/link/Link"
import Image from "components/media/ImageCLD"
import Video from "components/media/VideoCLD"
import Heading, { KickerCN, SubtitleCN } from "components/text/Heading"
import { fullGrid } from "css/grid"
import getMediaQuery from "css/breakpoints"

const Root = styled.section`
  align-items: center;
  cursor: pointer;
  display: grid;
  /* justify-items: center; */

  ${fullGrid}

  & img {
    display: block;
  }

  > * {
    grid-column: 1 / -1;
    grid-row: 1 / -1;
  }

  * {
    pointer-events: none;
  }

  a {
    pointer-events: auto;
  }
`

const Content = styled.div`
  /* align-items: center; */
  display: flex;
  flex-direction: column;
  /* row-gap: 2.5rem; */
  text-align: start;
  /* width: fit-content; */
  align-self: end;
  grid-column: 2 / span 6;
  margin-block: 0 16vw;

  ${getMediaQuery("m")} {
    margin-block: 0 8vw;
  }

  hgroup {
    display: flex;
    flex-direction: column;

    p {
      ${surtitle50}
      text-wrap: pretty;
    }
  }

  h2 {
    ${headline50}
    margin-block-end: 0.7rem;
  }

  & > p {
    ${body100}
    margin-block-end: 0.7rem;
  }

  a {
    padding: 0 !important;
  }

  /* a11y */
  html.prefers-contrast & {
    color: black !important;
    position: relative;

    ::after {
      background: white;
      content: "";
      height: 100%;
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
      width: calc(100% + 20px);
      z-index: -1;
    }
  }
`

export default function Push({ content, theme }) {
  const console = useConsole()

  function onClick(e) {
    if (e.target.tagName === "A") return
    const linkEl = e.target.getElementsByTagName("a")
    linkEl[0].click()
  }

  function Text({ title, chapo, label, url: href, paragraph }) {
    return (
      <Content>
        <hgroup>
          <p>{chapo}</p>
          <h2>{title}</h2>
        </hgroup>
        {paragraph.map((txt, i) => (
          <p key={`para-${i.toString()}`}>{txt}</p>
        ))}

        <Link className='inline' href={href}>
          {label}
        </Link>
      </Content>
    )
  }

  const text = content.find(item => item.text)?.text
  const asset = content.find(item => item.asset)?.asset
  const cta = content.find(item => item.cta)?.cta

  const videoSources = (asset.asset || []).filter(c => c.resource_type === "video")
  const posterSources = (asset.asset || []).filter(c => c.resource_type === "image")

  console.log("TestimoneePush(%o)", { video: videoSources }, { poster: posterSources })

  return (
    <Root className={theme || "dark-theme"} onClick={onClick}>
      {videoSources.length > 0 ? (
        <Video sources={videoSources} /*poster={{ sources: posterSources }}*/ autoPlay noButton sizes='100vw' />
      ) : posterSources.length > 0 ? (
        <Image sources={posterSources} sizes='100vw' />
      ) : null}
      {text && <Text {...text} {...cta} />}
    </Root>
  )
}
